import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Typography from '@material-ui/core/Typography';
import CursoInteresseContainer from '../containers/curso-interesse';
import DadosInteressadoContainer from '../containers/dados-interessado';
import GrupoFamiliarContainer from '../containers/grupo-familiar';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import CONSTANTS from '../constants';
import FinalizarContainer from '../containers/finalizar';
import LinearProgress from '@material-ui/core/LinearProgress';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
let _steps = Object.keys(CONSTANTS._STEPS).sort((a, b) => {
    if (CONSTANTS._STEPS[a].index > CONSTANTS._STEPS[b].index) {
        return 1;
    } else if (CONSTANTS._STEPS[a].index > CONSTANTS._STEPS[b].index) {
        return -1;
    }
    return 0;
}).map((item, indice) => {
    return CONSTANTS._STEPS[item];
});



export default class Solicitacao extends React.Component {


    componentDidMount() {
        if (document.querySelector(".scrollView")) {
            document.querySelector(".scrollView").scrollIntoView({ behaviour: "smooth" });
        }
    }

    render() {
        var form = (
            <div>

                <Divider />
                <br />
                <Stepper activeStep={this.props.activeStep} alternativeLabel className="scrollView">
                    {_steps.map(step => {
                        return (
                            <Step key={step.index}>
                                <StepLabel>{step.text}</StepLabel>
                            </Step>
                        );
                    })}
                </Stepper>
                <Divider />
                <br />  <br />
                {this.props.activeStep === CONSTANTS._STEPS.CURSO_INTERESSE.index ? <CursoInteresseContainer /> : null}
                {this.props.activeStep === CONSTANTS._STEPS.DADOS_INTERESSADO.index ? <DadosInteressadoContainer /> : null}
                {this.props.activeStep === CONSTANTS._STEPS.DADOS_GRUPO_FAMILIAR.index ? <GrupoFamiliarContainer /> : null}
                {this.props.activeStep === CONSTANTS._STEPS.FINALIZAR.index ? <FinalizarContainer /> : null}

                <div style={{
                    display: this.props.msgSucesso ? "none" : "block",
                    textAlign: "right", margin: "100px 0 30px 0"
                }}>
                    <Button
                        disabled={this.props.activeStep === 0}
                        onClick={this.props.onBackStep} variant="raised" color="primary" >
                        Anterior
             </Button>
                    <Button
                        style={{ margin: "0 10px" }}
                        disabled={(this.props.activeStep >= _steps.length - 1) || (this.props.activeStep == 1 && !this.props.dadosInteressado.cpfOK)}
                        variant="raised" color="primary" onClick={this.props.onNextStep} >
                        Próximo
             </Button>

                    <Button
                        disabled={this.props.finalizando || this.props.activeStep !== _steps.length - 1 || !this.props.aceite || !this.props.aceiteRegulamento}
                        variant="raised" color="primary" onClick={this.props.onFinalizar} >
                        Finalizar
             </Button>
                </div>
                {this.props.msgSucesso ? (<div
                    dangerouslySetInnerHTML={{
                        __html: this.props.msgSucesso
                    }}
                    style={{
                        lineHeight: '25px',
                        padding: "10px",
                        textAlign: "center"
                    }}></div>) : null}
                {this.props.finalizando ? <LinearProgress /> : null}
            </div>
        );

        var alteracao = (
            <div>

                <div style={{
                    textAlign: "center"
                }}>

                    <FormControl className='item-form'
                        style={{
                            textAlign: "center"
                        }}>

                        <TextField
                            type="number"
                            style={{ width: "150px" }}
                            id="pes-cpf"
                            label="CPF"
                            value={this.props.alteracao.pesCPF > 0 ? this.props.alteracao.pesCPF : ""}
                            onChange={(e) => this.props.changeCampoGenericoAlteracao('pesCPF', e.target.value)}
                            margin="normal"
                            helperText={"Somente números"}

                        />
                        <Button
                            disabled={this.props.alteracao.carregando}
                            onClick={this.props.getDadosParaAlteracao} variant="raised" color="primary" >
                            Continuar
                    </Button>
                    </FormControl>
                </div>
            </div>
        );
        return (
            <div>
                <Paper >
                    <Tabs
                        value={this.props.isAlteracao ? 1 : 0}
                        onChange={this.props.onChangeIsAlteracao}
                        indicatorColor="primary"
                        textColor="primary"
                        centered
                    >
                        <Tab label="Nova Solicitação" />
                        <Tab label="Já Realizei a Solicitação " />
                    </Tabs>
                </Paper>
                <br /><br />
                {this.props.isAlteracao ? alteracao : form}

            </div>

        );
    }
}


// WEBPACK FOOTER //
// ./src/components/solicitacao.js